<div id="edit-subscription-dialog" class="edit-subscription-dialog">
    @if (subscription()) {
        <mat-dialog-content class="d-flex flex-row flex-wrap align-items-start justify-content-start p-3 gap-2">
            <mat-form-field appearance="fill">
                <mat-label>Status</mat-label>
                <mat-select
                    name="status"
                    [(ngModel)]="subscription()!.status"
                    required
                    (ngModelChange)="onSubscriptionUpdated()"
                >
                    @for (status of subscriptionStatusTypes; track status) {
                        <mat-option [value]="status">{{ status | subscriptionStatus }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Start Date</mat-label>
                <input
                    matInput
                    [matDatepicker]="startPicker"
                    name="startDate"
                    [(ngModel)]="subscription()!.startDate"
                    (ngModelChange)="onSubscriptionUpdated()"
                />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>End Date</mat-label>
                <input
                    matInput
                    [matDatepicker]="endPicker"
                    name="endDate"
                    [(ngModel)]="subscription()!.endDate"
                    (ngModelChange)="onSubscriptionUpdated()"
                />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>

            <div class="table-scroll-container w-100">
                <table mat-table [dataSource]="subscription()!.pricingPackages" class="mat-elevation-z8">
                    <ng-container matColumnDef="idx">
                        <th mat-header-cell *matHeaderCellDef>
                            <button mat-icon-button (click)="addPackage()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element"></td>
                    </ng-container>
                    <ng-container matColumnDef="packageName">
                        <th mat-header-cell *matHeaderCellDef>Package Name</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="fill">
                                <mat-select
                                    name="pricingPackageId"
                                    [(ngModel)]="element.pricingPackageId"
                                    (ngModelChange)="onSubscriptionUpdated()"
                                    required
                                >
                                    @for (package of pricingPackages(); track package.id) {
                                        <mat-option [value]="package.id">{{ package.name }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="isMain">
                        <th mat-header-cell *matHeaderCellDef>Is Main</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox
                                [ngModel]="element.isMain"
                                (click)="onIsMainUpdate(element)"
                                [disabled]="isAddonPackage(element.pricingPackageId)"
                            ></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="expirationDate">
                        <th mat-header-cell *matHeaderCellDef>Expiration Date</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-form-field appearance="fill">
                                <input
                                    matInput
                                    [matDatepicker]="expDate"
                                    name="expDate"
                                    [(ngModel)]="element.expirationDate"
                                    (ngModelChange)="onSubscriptionUpdated()"
                                />
                                <mat-datepicker-toggle matSuffix [for]="expDate"></mat-datepicker-toggle>
                                <mat-datepicker #expDate></mat-datepicker>
                            </mat-form-field>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex flex-row align-items-center justify-content-between">
                                <button mat-raised-button color="warn" (click)="delete(element)">Delete</button>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        </mat-dialog-content>
    }

    <mat-dialog-actions align="center">
        <button mat-stroked-button tabindex="-1" (click)="update()" [disabled]="!isComplete()">OK</button>
        <button mat-stroked-button mat-dialog-close>Cancel</button>
    </mat-dialog-actions>
</div>
